import axios from 'axios';
import { Urls } from '../../../common/apis/urls';
import { LoginRequest, LoginResult } from "../contracts";

export async function login(payload: LoginRequest): Promise<LoginResult> {
    const { data } = await axios.post(Urls.login(), payload);
    return data;
}